import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import RadioToggleButton from 'components/RadioToggleButton';
import RadioToggleButtonFlexContainer from 'components/RadioToggleButtonFlexContainer';
import { ChangeEventHandler, useEffect, useState } from 'react';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  const [selectedValue1, setSelectedValue1] = useState<string | undefined>(
    undefined,
  );
  const onChangeHandler1: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSelectedValue1(e.currentTarget.value);
  };

  const [selectedValue2, setSelectedValue2] = useState<string | undefined>(
    'two',
  );
  const onChangeHandler2: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSelectedValue2(e.currentTarget.value);
  };

  const [selectedValue3, setSelectedValue3] = useState<string | undefined>(
    undefined,
  );
  const onChangeHandler3: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSelectedValue3(e.currentTarget.value);
  };

  const [selectedValue4, setSelectedValue4] = useState<string | undefined>(
    'two',
  );
  const onChangeHandler4: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSelectedValue4(e.currentTarget.value);
  };
  useEffect(() => {
    let counter = 0;
    const timeout = setInterval(() => {
      const elements = [
        ...(document.querySelectorAll('input[type=radio][name=group4]') as any),
      ];
      counter += 1;
      if (counter >= elements.length) {
        counter = 0;
      }
      elements[counter].click();
    }, 1000);
    return () => {
      clearInterval(timeout);
    };
  }, []);

  return (
    <AboutUsModule background="white">
      <AboutUsSiteContainer>
        <h3 className="aboutUsTypographyHeaderLarge">
          Radio button toggle button
        </h3>
        <p>A radio button that looks like a toggle button.</p>
        <p>
          Generally, these are shown in some kind of grid or wrapping flexbox.
          It can also be used inside a RadioToggleButtonFlexContainer, which
          will take care of laying out the buttons into two columns, or full
          width for the remaining column.
        </p>
        <p>
          The "badges" on the RadioToggleButtons extend out of the top of the
          component. The consumer of the component is responsible for ensuring
          that there is enough spacing above the RadioToggleButton for it to
          appear.
        </p>

        <div style={{ maxWidth: 400, marginBottom: 16 }}>
          <RadioToggleButtonFlexContainer>
            <RadioToggleButton
              radioGroupName="group1"
              selectedValue={selectedValue1}
              value="one"
              text="Value 1"
              subtext="info one"
              onChange={onChangeHandler1}
            />
            <RadioToggleButton
              radioGroupName="group1"
              selectedValue={selectedValue1}
              value="two"
              text="Value 2"
              subtext="info two"
              badgeText="Badge text"
              onChange={onChangeHandler1}
            />
            <RadioToggleButton
              radioGroupName="group1"
              selectedValue={selectedValue1}
              value="three"
              text="Value 3"
              subtext="info three"
              onChange={onChangeHandler1}
              badgeText="😸 Cats are great 😸"
              badgeStyle="STYLE1"
            />
          </RadioToggleButtonFlexContainer>
        </div>

        <p>
          Two options, no subtext, state initialised with one of the options'
          value.
        </p>
        <div style={{ maxWidth: 400, marginBottom: 16 }}>
          <RadioToggleButtonFlexContainer>
            <RadioToggleButton
              radioGroupName="group2"
              selectedValue={selectedValue2}
              value="one"
              text="Value 1"
              onChange={onChangeHandler2}
            />
            <RadioToggleButton
              radioGroupName="group2"
              selectedValue={selectedValue2}
              value="two"
              text="Value 2"
              onChange={onChangeHandler2}
            />
          </RadioToggleButtonFlexContainer>
        </div>

        <p>Four options, ticket style</p>
        <div style={{ maxWidth: 400, marginBottom: 16 }}>
          <RadioToggleButtonFlexContainer>
            <RadioToggleButton
              radioGroupName="group3"
              selectedValue={selectedValue3}
              value="1"
              subtext="info one"
              onChange={onChangeHandler3}
              displayStyle="TICKET"
            >
              <span>One line</span>
            </RadioToggleButton>
            <RadioToggleButton
              radioGroupName="group3"
              selectedValue={selectedValue3}
              value="2"
              subtext="info two"
              badgeText="Badge text"
              onChange={onChangeHandler3}
              displayStyle="TICKET"
            >
              <span>Two lines</span>
            </RadioToggleButton>
            <RadioToggleButton
              radioGroupName="group3"
              selectedValue={selectedValue3}
              value="3"
              subtext="info three"
              onChange={onChangeHandler3}
              displayStyle="TICKET"
            >
              <span>Three lines</span>
            </RadioToggleButton>
            <RadioToggleButton
              radioGroupName="group3"
              selectedValue={selectedValue3}
              value="4"
              subtext="info three"
              onChange={onChangeHandler3}
              displayStyle="TICKET"
            >
              <span>Four lines</span>
            </RadioToggleButton>
          </RadioToggleButtonFlexContainer>
        </div>

        <p>
          Programatically changing the radio button, which mimics what happens
          when external state updates the radio button values for the entire
          group
        </p>
        <div style={{ maxWidth: 400, marginBottom: 16 }}>
          <RadioToggleButtonFlexContainer>
            <RadioToggleButton
              radioGroupName="group4"
              selectedValue={selectedValue4}
              value="one"
              text="Value 1"
              onChange={onChangeHandler4}
            />
            <RadioToggleButton
              radioGroupName="group4"
              selectedValue={selectedValue4}
              value="two"
              text="Value 2"
              onChange={onChangeHandler4}
            />
            <RadioToggleButton
              radioGroupName="group4"
              selectedValue={selectedValue4}
              value="three"
              text="Value 3"
              onChange={onChangeHandler4}
            />
          </RadioToggleButtonFlexContainer>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'RadioToggleButton',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
